// Theme switching utilities
// Shared between main app and storybook

const darkModeQuery = matchMedia('(prefers-color-scheme: dark)');

export function getSystemTheme() {
  return darkModeQuery.matches ? 'dark' : 'light';
}

export function resolveTheme(theme) {
  // Beta: default to light theme until dark mode is fully tested
  // Revert this whole commit when the beta is over
  return theme || 'light';
}

function swapStylesheet(themeName) {
  const currentLink = document.getElementById('active-theme');
  const template = document.getElementById('theme-' + themeName);
  if (!currentLink || !template) return;

  const newLink = template.content.querySelector('link').cloneNode(true);
  newLink.id = 'active-theme';
  newLink.onload = function() {
    currentLink.remove();
  };
  currentLink.id = 'old-theme';
  currentLink.after(newLink);
}

var currentTheme = resolveTheme(localStorage.getItem('theme'));

export function applyTheme(theme) {
  const resolved = resolveTheme(theme);
  if (resolved === currentTheme) return;
  currentTheme = resolved;
  swapStylesheet(resolved);
}

export function saveTheme(theme) {
  if (theme === null) {
    localStorage.removeItem('theme');
  } else {
    localStorage.setItem('theme', theme);
  }
}

export function initThemePorts(ports) {
  ports.setTheme.subscribe(function(theme) {
    saveTheme(theme);
    applyTheme(theme);
  });

  ports.configuredTheme.send(localStorage.getItem('theme'));
  ports.systemTheme.send(darkModeQuery.matches);

  darkModeQuery.addEventListener('change', function(e) {
    ports.systemTheme.send(e.matches);
    if (!localStorage.getItem('theme')) {
      applyTheme(null);
    }
  });
}
